/*
    This helper takes a string and searches for particular markers to add highlights to text.
    {{beginHighlight}} is the default highlight and will be replaced with `<span class="highlight">`
    {{beginHighlight-colour}} specifies a colour for the highlight to be - eg red, purple, green etc and will be replaced with `<span class="highlight--red">`
    {{endHighlight}} closes the span
    There may be more than one highlight marker in the text.

    You will then want to add something like this to your CSS, adjusting for your design:
    .highlight {
        background-color: #707070;

        &--purple {
            background-color: #9c80ce;
        }

        &--red {
            background-color: #bb1919;
        }

        &--blue {
            background-color: #1380a0;
        }

        &--green {
            background-color: #06bf8e;
        }
    }
*/
const highlightText = (string) => {
    let output = string;
    const regex = /\{{(.*?)\}}/g; // find anything between double curly braces
    const searchString = regex.exec(output);
    if (!searchString || !searchString[0].toLowerCase().includes('highlight')) return output; // return if there is no double bracket marker in the string, or if the marker is not for highlighting

    const matches = output.match(regex);
    matches.forEach(match => {
        if (match.toLowerCase().includes('begin')) output = findHighlight(output, match);
    });

    output = output.replace(/{{endHighlight}}/g, '</span>');
    return output;
};

function findHighlight(str, searchString) {
    const defaultColour = 'black';
    const marker = searchString;
    const highlightIndex = str.indexOf(marker);
    const colour = (marker.includes('-')) ? marker.split('-')[1].split('}')[0] : defaultColour;

    const span = (colour === defaultColour) ? '<span class="highlight">' : `<span class="highlight highlight--${colour}">`;
    const indexOfLastCharacterToReplace = highlightIndex + marker.length;
    return replaceBetween(str, highlightIndex, indexOfLastCharacterToReplace, span);
}

function replaceBetween(str, start, end, replacement) {
    return str.substring(0, start) + replacement + str.substring(end);
}

module.exports = highlightText;
